import React from 'react';
import NewVSStep4 from './NewVSStep4';

const NewVSStep4Container = ({ formikProp }) => {
  return <NewVSStep4 formikProp={formikProp} />;
};

export default NewVSStep4Container;
